import { render, staticRenderFns } from "./HintsPage.vue?vue&type=template&id=115c8912&scoped=true&"
import script from "./HintsPage.vue?vue&type=script&lang=js&"
export * from "./HintsPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=115c8912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c8912",
  null
  
)

export default component.exports